import * as React from 'react';
import { observer } from 'mobx-react';
import { IConfigurationViewButtonParams } from './IConfigurationViewButtonParams';

@observer
export class ConfigurationViewButton extends React.Component<IConfigurationViewButtonParams> {
  constructor(props: IConfigurationViewButtonParams) {
    super(props, undefined);
  }

  render() {
    const disabledClass = this.props.enabled ? '' : 'disabled-view';
    return (
      this.props.visible && (
        <div
          className="configuration-button-wrapper ConfigurationViewButton"
          onClick={this.props.onClick}
        >
          <div className="switch-wrapper">
            <span
              className="switch-background"
              style={{ backgroundColor: this.props.enabled ? '#EC691A' : '#c1c1c1' }}
            ></span>
            <span
              className="club-type-wrapper"
              style={{ right: this.props.enabled ? '6px' : '25px' }}
            ></span>
          </div>
          <div
            className={`view-btn ${this.props.classNameForViewButton} col-xs-12 ${disabledClass}`}
            onClick={() => this.props.onClick}
          >
            <img src={this.props.buttonIcon} alt="" />
            <span>{this.props.buttonName}</span>
          </div>
        </div>
      )
    );
  }
}
